// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ConsumablesFormStepSection_wrapper__QFDxX","title":"ConsumablesFormStepSection_title__dTHzw","contentWrapper":"ConsumablesFormStepSection_contentWrapper__v8BRA"};